import React from 'react';
import OrderLogText from '../OrderLogText/OrderLogText';

interface IProps {
  text?: string | number;
  skeletonWidth: number;
  className?: string;
}

export default class OrderLogListItem extends React.Component<IProps, {}> {
  render() {
    return (
      <li className={`d-flex align-items-center family-medium color-dark text-size-16 pr-2 ${this.props.className || ''}`}>
        {OrderLogText(this.props)}
      </li>
    );
  }
}
